import { AxiosRequestConfig, AxiosResponse } from "axios";

export const uploadFile = async (
  method: <T = any, R = AxiosResponse<T, any>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
  ) => Promise<R>,
  uploadedFile: File,
  apiUrl: string,
  contentType: string,
  formData: FormData = new FormData(),
) => {
  return new Promise<any>(async (resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async () => {
      const result = reader.result;

      if (
        result &&
        (typeof result === "string" || result instanceof ArrayBuffer)
      ) {
        try {
          const blob = new Blob([result], { type: contentType });

          formData.append("File", blob, uploadedFile.name);
          const response = await method(apiUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          resolve(response?.data);
        } catch (error) {
          console.error("Error uploading file", error);
          reject(error);
        }
      } else {
        console.error("Error: File result is invalid or null");
        reject(new Error("Invalid file result"));
      }
    };

    reader.readAsArrayBuffer(uploadedFile);
  });
};
